import {get} from 'lodash';

import {
  DVR_SNAPSHOTS_REQUEST,
  DVR_SNAPSHOTS_SUCCESS,
  DVR_SNAPSHOTS_OFFLINE,
  DVR_SNAPSHOTS_FAILURE,
  DVR_SNAPSHOTS_NOT_AVAILABLE,
  DVR_SNAPSHOTS_CAROUSEL_OPENED,
  DVR_SNAPSHOTS_CAROUSEL_CLOSED
} from './DVRSnapshotsActionsType';

const initialState = {
  isLoadingSnapshots: false,
  isSnapshotsAvailable: true,
  isDvrOnline: true,
  snapshots: {
    channels: []
  }
};

export default function getSnapshots(state = initialState, action) {
  const type = get(action, 'type');

  switch (type) {
    case DVR_SNAPSHOTS_REQUEST:
      return {
        ...state,
        isLoadingSnapshots: true,
        isSnapshotsAvailable: initialState.isSnapshotsAvailable,
        isDvrOnline: initialState.isDvrOnline,
        snapshots: {
          channels: []
        }
      };
    case DVR_SNAPSHOTS_SUCCESS:
      return {
        ...state,
        isLoadingSnapshots: false,
        isSnapshotsAvailable: initialState.isSnapshotsAvailable,
        isDvrOnline: initialState.isDvrOnline,
        snapshots: get(action, 'payload.snapshots', [])
      };
    case DVR_SNAPSHOTS_OFFLINE:
      return {
        ...state,
        isLoadingSnapshots: false,
        isSnapshotsAvailable: initialState.isSnapshotsAvailable,
        isDvrOnline: false,
        snapshots: {
          channels: []
        }
      };
    case DVR_SNAPSHOTS_NOT_AVAILABLE:
      return {
        ...state,
        isLoadingSnapshots: false,
        isSnapshotsAvailable: false,
        isDvrOnline: initialState.isDvrOnline,
        snapshots: {
          channels: []
        }
      };
    case DVR_SNAPSHOTS_FAILURE:
      return {...state, ...initialState, snapshots: {
        channels: []
      }};
    case DVR_SNAPSHOTS_CAROUSEL_OPENED:
      return {
        ...state,
        activeChannelName: get(action, 'payload.activeChannelName', null),
        dvrSnapshotsCarouselOpened: true
      };
    case DVR_SNAPSHOTS_CAROUSEL_CLOSED:
      return {
        ...state,
        dvrSnapshotsCarouselOpened: false
      };
    default:
      return state;
  }
}
